import {Component} from '@angular/core';
import {ActionSheetController, AlertController, LoadingController, NavController} from 'ionic-angular';
import {LoggerService} from '../../providers/logger-service';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'page-user-profile',
  templateUrl: 'user-profile.html',
})
export class UserProfilePage {

  profiles: FirebaseListObservable<any>;

  user: Observable<firebase.User>;

  errorMessage: string = 'unable to load your profile data';
  isDataAvailable:boolean = true;

  constructor(public navCtrl: NavController,
              private logger: LoggerService,
              public alertCtrl: AlertController,
              public actionSheetCtrl: ActionSheetController,
              public loadingCtrl: LoadingController,
              public db: AngularFireDatabase,
              public afAuth: AngularFireAuth)
  {
    this.user = afAuth.authState;

    let loader = this.loadingCtrl.create({
      content: 'Retrieving your profile..',
    });

    this.logger.log.debug('loader.present()');

    loader.present().then(() => {
      this.profiles = db.list('userProfile');
      loader.dismiss();
    }).catch((ex) => {
      console.error('Error connecting to database/user profile', ex);
      //TODO: create alertCtrl
    });
  }

  goToProfile(){
    //TODO! handle promise and assing to profiles
    // this.profileProvider.getUserProfile();
  }


  updateEmail(profileId,email){
    let title: string = 'Email';
    let message: string = 'Update the email with your profile';
    let placeholder:string = 'email'; //needs to match profile!!
    this.updateProfile(profileId, email, title, message, placeholder );
  }

  /**
   *
   * @param profileId
   * @param profileKey
   *
   * TODO: in a world we have infinite time we would gather at this stage what is missing,
   * at the start we will give the user total control of what they can and can't do
   */

  updateProfile(profileId, profileKey, title, message, placeholder) {
    let prompt = this.alertCtrl.create({
      title: title,
      message: message,
      inputs: [
        {
          name: placeholder,
          placeholder: placeholder,
          value: profileKey
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

            this.logger.log.debug('Cancel clicked: ' + data);
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save', //this should be update or Save depending on whether a value exists
          handler: data => {

            this.logger.log.debug('Update ' + placeholder + ' with ' + profileKey + ' data: ' + data.email + '|' + JSON.stringify(data));
            console.log('Update ' + placeholder + ' with ' + profileKey + ' data: ' + data.email + '|' + JSON.stringify(data));

            this.profiles.update(profileId, { email: data.email }).then(() => {
              console.log('updated profile with ' + JSON.stringify(data));
            }).catch((ex) => {
              console.error('Error updating profile with data ' + data + ' error ' +  ex);
              //TODO: create alertCtrl
            });
          }
        }
      ]
    });
    prompt.present();
  }

  //TODO: when user leaves this pages for teh first time update the profile.

}



// WEBPACK FOOTER //
// ./src/pages/user-profile/user-profile.ts